import { type ChangeEvent, createContext, type FC, type MouseEvent, type ReactElement, useState } from 'react';
import { usePagination } from '../content/hooks';
import type { LegalSortingFields, LegalsModel, Order } from '../models';

interface ILegalsContext {
  legalsUpdate: boolean;
  toggleLegalsUpdate: () => void;
  legals: LegalsModel[];
  setLegals: (val: LegalsModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: LegalSortingFields;
  setOrderBy: (val: LegalSortingFields) => void;
  handlePageChange: (_event: any, newPage: number) => void;
  handleLimitChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleRequestSort: (_event: MouseEvent, property: LegalSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const LegalsContext = createContext<ILegalsContext>({} as ILegalsContext);

export const LegalsProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [legalsUpdate, setLegalsUpdate] = useState(false);
  const toggleLegalUpdate = (): void => setLegalsUpdate(!legalsUpdate);

  const {
    page,
    setPage,
    limit,
    setLimit,
    count,
    setCount,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    handlePageChange,
    handleLimitChange,
    handleRequestSort
  } = usePagination<LegalSortingFields>(toggleLegalUpdate, 'name', 'desc');

  const [legals, setLegals] = useState<LegalsModel[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <LegalsContext.Provider
      value={{
        legalsUpdate,
        toggleLegalsUpdate: toggleLegalUpdate,
        legals,
        setLegals,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        handlePageChange,
        handleLimitChange,
        handleRequestSort,
        loading,
        setLoading
      }}
    >
      {children}
    </LegalsContext.Provider>
  );
};
